const SCHEDULING_GROUP_NAME_ERROR_ACTIONS = {
  showSchedulingGroupNameError: 'SHOW_SCHEDULING_GROUP_NAME_ERROR',
  hideSchedulingGroupNameError: 'HIDE_SCHEDULING_GROUP_NAME_ERROR',
};

export default SCHEDULING_GROUP_NAME_ERROR_ACTIONS;
